<div class="pb-3">
  <div
    [class.grid]="
      hasDemographicPermissions && requests != null && canEnableTimeOff && hasTimeOffPermissions
    "
    class="grid">
    <div
      *ngIf="(canViewDemographicRequests | async) && hasDemographicPermissions && requests != null">
      <div
        class="card tile-shadow h-100"
        [class.w-100]="!canEnableTimeOff || !hasTimeOffPermissions">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <h3 class="fw-bold">Review Detail Requests</h3>
                <div>
                  <span class="badge badge-red badge-circle" *ngIf="requests.length > 0">{{
                    requests.length
                  }}</span>
                </div>
              </div>
              <p>
                View and manage changes to employee details like direct deposit accounts and
                addresses.
              </p>
            </div>
          </div>
        </div>
        <div class="card-footer bg-white border-top-0">
          <div class="h-100 w-100 text-start d-flex flex-column justify-content-center">
            <div>
              <button routerLink="approvals" class="btn btn-tertiary">View Requests</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="canEnableTimeOff && hasTimeOffPermissions">
      <div
        class="card tile-shadow h-100"
        [class.w-100]="!hasDemographicPermissions || !(canViewDemographicRequests | async)">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <h3 class="fw-bold">Review Time Off Requests</h3>
                <div>
                  <span class="badge badge-red badge-circle" *ngIf="timeOffCount > 0">{{
                    timeOffCount
                  }}</span>
                </div>
              </div>
              <p>View and manage employee time off requests.</p>
            </div>
          </div>
        </div>
        <div class="card-footer bg-white border-top-0">
          <div class="h-100 w-100 text-start d-flex flex-column justify-content-center">
            <div>
              <button routerLink="time-off" class="btn btn-tertiary">View Requests</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
